import H from 'history'
import queryString from 'query-string'
import { BreachEvent } from 'common/events/breachEventTypes'
import { sendLaunchDarklyEvent } from 'common/feature-togglings/ClientABTesting/ab-testing'
import { utm_medium_breach, SSWQueryString } from 'common/ssw'
import { DataLayerEventName } from 'common/helpers/DataLayerEventName'

export function createIsEntitledChangeHandler(
    creativeName: string,
    deal: string,
    location: H.Location,
    onEvent: (event: BreachEvent) => void
): (event: { entitled: boolean; loggedInStatusChecked: boolean }) => void {
    return ({ entitled, loggedInStatusChecked }) => {
        if (!loggedInStatusChecked) {
            return
        }

        const eventPayload: BreachEvent['payload'] = {
            paywallType: 'freemium',
            leadDepth: 0,
            creative: creativeName,
            breachScreenType: 'inline',
            popupMethod: 'auto',
            deal,
            pricepoint: [7, 8],
        }

        if (entitled) {
            const query = queryString.parse(location.search)

            // Need to ensure we convert the necessary items to numbers for the logic check below
            const sswQueryString: SSWQueryString = {
                transactionId: Number(query.transactionId),
                transactionTotal: Number(query.transactionTotal),
                transactionTax: Number(query.transactionTax),
                productSku: query.productSku,
                productName: query.productName,
                clickOrigin: query.clickOrigin,
            }

            const { clickOrigin, ...sswTransaction } = sswQueryString
            // Only raise when click origin is breach
            if (sswTransaction.transactionId && clickOrigin === utm_medium_breach) {
                onEvent({
                    type: DataLayerEventName.breachScreenComplete,
                    originator: 'breachscreen',
                    payload: {
                        ...eventPayload,
                        ...sswTransaction,
                    },
                })
                sendLaunchDarklyEvent('simplified-mobile-breach-screen-conversion-event', {
                    transactionId: sswTransaction.transactionId,
                })
            }
        } else {
            onEvent({
                type: DataLayerEventName.breachScreenAvailable,
                originator: 'breachscreen',
                payload: eventPayload,
            })
        }
    }
}
